export default "__VITE_ASSET__a85f1fa5__"